import { Component, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, Subscription } from 'rxjs';

import { QueryService, AuthService, ClipService } from '@app/core/services';

import { configUrl } from '@env/environment';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-combined-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.scss'],
})
export class BranchComponent implements OnDestroy {
  postId = '';

  post: any = null;
  replies: any[] = null;

  postLoaded = false;
  repliesLoaded = false;

  newClipSubscription: Subscription;

  get loaded(): boolean {
    return this.postLoaded && this.repliesLoaded;
  }

  constructor(
    public http: HttpClient,
    public qs: QueryService,
    public authService: AuthService,
    private location: Location,
    private route: ActivatedRoute,
    private clipService: ClipService,
  ) {
    this.route.params.subscribe((param: any) => {
      this.reset();
      this.postId = param.id;
      this.loadPost();
      this.loadReplies();
    });

    this.clipService.newClip$.subscribe((clip) => {
      if (clip.parentid === this.post.id) {
        this.loadReplies();
      }
    });
  }

  ngOnDestroy() {
    this.newClipSubscription?.unsubscribe();
  }

  reset() {
    this.postId = '';

    this.post = null;
    this.replies = null;

    this.postLoaded = false;
    this.repliesLoaded = false;
  }

  loadPost() {
    const url = `${configUrl.getClipByIdUrl}${this.postId}`;
    this.http
      .get(url)
      .pipe(
        switchMap((post: any) =>
          post.parentid
            ? this.loadParent(post.parentid).pipe(
                map((parent) => ({
                  ...post,
                  parent,
                })),
              )
            : of(post),
        ),
      )
      .subscribe((response) => {
        this.postLoaded = true;
        this.post = response;

        if (this.post.parentid) {
          this.loadParent(this.post.parentid);
        }
      });
  }

  loadReplies() {
    const url = `${configUrl.getClipChildrenByIdUrl}${this.postId}?cliptype=All`;
    this.http.get(url).subscribe((response: any[]) => {
      this.replies = response.reverse();

      this.repliesLoaded = true;
    });
  }

  private loadParent(parentId: string): Observable<any> {
    const url = `${configUrl.getClipByIdUrl}${parentId}`;
    return this.http.get(url);
  }
}
